import React, { useState, useEffect  } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import $ from 'jquery';

import * as actions from '../../../redux/newOffer';
import { Field, FieldRenderProps } from 'react-final-form';
import Caret from '../../../svg/caret';
import Checkbox from '../../Checkbox';
import CheckboxMultiple from '../../CheckBoxMultiple';
import ModalQuestion from '../../ModalQuestion';
import { Row } from '../../Grid';
import { CategoryName } from '../../Common';
import { enm } from '../../../services/api';
import { cmToInches, sliceIntoChunks } from '../../../helpers'
import { Col } from 'react-bootstrap';

const locutus = require('locutus/php/math/fmod');

type AdapterProps = FieldRenderProps<any, HTMLElement>;

const has = (arr, item) => {
  if (!Array.isArray(arr)) return false;
  return arr.indexOf(item) !== -1;
};

const offerTypes = {
  anytime: 'Anytime',
  timed: 'Timed Event',
  swing_by: 'Swing by',
  reservation_required: 'Reservation Required',
  gift: 'Gift',
  sponsored_content: 'Sponsored Content',

  // Pick up Job offer creation from this
  job: 'Job'
};

const FieldWithError = ({ name, component, ...rest }) => {
  
  let result;

  if (typeof component === 'string')
    result = (props) =>
      React.createElement(component, {
        ...props.input,
        ...rest,
        name,
        className: 'create-form-input',
      });
  else
    result = (props) =>
      React.createElement(component, { ...props, ...rest, name, className: 'create-form-input' });

  return (
    <Field
      name={name}
      render={(props) => (
        <>
          <ErrorShow data={props.meta} /> {result(props)}
        </>
      )}
    />
  );
};

const GroupUpdater = ({ input, disabled, values, ...rest }) => {
  const old_value =
    input.name === 'group_max_number' ? values.group_max_size : values.group_max_number;
  return (
    <input
      {...input}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        input.onChange(e);
        rest.mutator(parseInt(e.target.value) * old_value);
      }}
    />
  );
};

const CheckBoxAdapter = ({
  input: { onChange, value },
  disabled,
  ...rest
}: AdapterProps & { disabled: boolean }) => {
  return (
    <Checkbox
      flip={() => !disabled && onChange(!value)}
      status={value}
      disabled={disabled}
      {...rest}
    />
  );
};

const OfferSelect = styled.div`
  width: 300px;
  height: 40px;
  border-radius: 2px;
  padding-left: 15px;
  text-align: left;
  letter-spacing: 0.3px;
  color: #555555;
  border: solid 1px #eeeeee;
  background-color: #ffffff;
  cursor: pointer;
`;

const CaretContainer = styled.div`
  display: inline-block;
  float: right;
  padding-right: 15px;
`;

const SelectTypeAdapter0 = (props: {
  createNewOffer: Function;
  business: Business;
  reset: Function;
  input: any;
}) => {

  const [choice, setChoice] = useState('');

  return (
    <>
      <ModalQuestion
        title="Change offer type?"
        leftName="Cancel"
        rightName="OK"
        id="changeOfferType"
        function={() => {
          props.createNewOffer(props.business, choice);
          props.reset();
        }}
      >
        Switching offer type will erase all information <br />
        you've entered and start a new offer
      </ModalQuestion>
      <div className="dropdown type-select">
        <OfferSelect data-toggle="dropdown">
          {offerTypes[props.input.value]}
          <CaretContainer>
            <Caret />
          </CaretContainer>
        </OfferSelect>
        <div className="dropdown-menu type-select">
          {Object.keys(offerTypes).map((item) => (
            <div
              className="dropdown-item"
              key={item}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (!props.input.value) {
                  props.createNewOffer(props.business, item);
                  props.reset();
                  return;
                }
                setChoice(item);
                $('#changeOfferType').modal('show');
              }}
            >
              {offerTypes[item]}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const SelectTypeAdapter = connect(
  ({ offer, business }: any) => ({ offer, business }),
  actions
)(SelectTypeAdapter0);

const ErrorShow = (props) => {
  if (props.data.error && props.data.touched)
    return <div style={{ color: 'red' }}>{props.data.error}</div>;
  else return null;
};

const CitiesAdapter = ({ input: { value }, meta }: AdapterProps) => {

  const [cities, setCities] = useState<Array<Array<any>>>();

  useEffect(() => {

    enm.getCities()
      .then((response: any) => {

        setCities(sliceIntoChunks(response.data, Math.ceil(response.data.length / 2)));
        
      });

  }, []);

  return (
    <div className="row" style={{ paddingLeft: '15px', width: '60%', paddingTop: '5px' }}>
      
      <ErrorShow data={meta} />

      {(cities !== undefined) ? cities.map((items: Array<Array<any>>, i) => (
        <div className="col" key={i}>
          {(items !== undefined && items.length > 0) ? items.map((item: any) => (
            <Row key={item['id']}>
              <div>{singleCheckbox("city_ids", value, item['id'])}</div>
              <CategoryName>{item['name']}</CategoryName>
            </Row>
          )) : null}
        </div>
      )) : null}

    </div>
  );
};

const SimpleCheckboxes = (props: AdapterProps) => {

  const name = props['input']['name'];
  const size = props['size'] ?? 4;
  const line = 4;

  const chunks = sliceIntoChunks(props['items'] ?? [], Math.ceil(size))

  return (
    <div className="row" style={{  width: '80%', paddingTop: '5px' }}>
      <Field name={name + "s"} render={(p) => (
        <>
          {(chunks !== undefined) ? chunks.map((items: Array<Array<any>>, i) => (
            <Row key={name + i.toString()}>
              {(items !== undefined && items.length > 0) ? items.map((item: any) => (
                <Col key={name + item['key']}>
                  <div>
                    {singleCheckbox(name, props.input.value, item['key'])}
                    <CategoryName style={{left: '14px', top: '-22px', position: 'relative'}}>{item['title']}</CategoryName>
                  </div>
                </Col>
              )) : null}

              {/* Add empty space for better alignment */}
              {items.length < line ? Array(line - items.length).fill(Math.random()).map((v) => (<Col className={"A"} key={v + Math.random()}></Col>)) : null}
            </Row>
          )) : null}
        </>
      )}></Field>
    </div>
  );
};

const SimpleFilledSelect = (props: AdapterProps) => {

  const items = props['items'] ?? [];
  const title = props['title'] ?? 'us_title';
  const name  = props.input.name;

  return (
    <div className="row" style={{ paddingLeft: '15px', width: '80%', paddingTop: '5px' }}>
      <select name={name} onChange={props['input'].onChange} className="form-control" defaultValue={props['input']['value'] ?? ''}>
        <option value={''} disabled></option>
        {items.map((item, index) => (
          <option key={name + index.toString()} value={item['value'] ?? item['size']}>{item[title]}</option>
        ))}
      </select>
    </div>
  );
};

const ConfigurableSelect = (props: AdapterProps) => {

  const bounds = props['boundconfiguration'];
  const items  = Array.from({ length: (bounds['upperBound']['metric'] - bounds['lowerBound']['metric']) + 1}, (_, i) => i + bounds['lowerBound']['metric'])
  const name   = props['input']['name'];

  return (
    <div className="row" style={{ paddingLeft: '15px', width: '80%', paddingTop: '5px' }}>
      <select name={name} onChange={props['input'].onChange} className="form-control" defaultValue={props['input']['value'] ?? ''}>
        <option value={''} disabled></option>
        {items.map((item, index) => (
          <option value={item * 10} key={name + index.toString()}>{cmToInches(item, props['boundonlyinches'] ?? false)} ({item + 'cm'})</option>
        ))}
      </select>
    </div>
  );
};

const CategoriesAdapter = ({ input: { value }, meta }: AdapterProps) => {

  const categories1 = ['food', 'nightlife', 'beauty', 'retail'];
  const categories2 = ['fitness', 'culture', 'services'];

  return (
    <div className="row" style={{ paddingLeft: '15px', width: '60%', paddingTop: '5px' }}>
      <ErrorShow data={meta} />
      <div className="col">
        {categories1.map((item) => (
          <Row key={item}>
            <div>{singleCheckbox("categories", value, item)}</div>
            <CategoryName>{item.capitalize()}</CategoryName>
          </Row>
        ))}
      </div>

      <div className="col">
        {categories2.map((item) => (
          <Row key={item}>
            <div>{singleCheckbox("categories", value, item)}</div>
            <CategoryName>{item.capitalize()}</CategoryName>
          </Row>
        ))}
        <Row>
          <div>
            <Field
              name="is_vegan"
              render={(props) => <CheckBoxAdapter {...props} disabled={!has(value, 'food')} />}
            />
          </div>
          <CategoryName>Vegan friendly</CategoryName>
        </Row>
      </div>
    </div>
  );
};

function singleCheckbox(name: string, content: any, value: string) {
  return (
    <Field
      name={name}
      content={content}
      component={CheckboxMultiple}
      value={value}
      type="checkbox"
    />
  );
}

const SpotAdapter = ({ input, ...rest }) => {

  useEffect(() => {

    if (rest.onChanged) {

      rest.onChanged(input.value);
    }

  }, [input.value]);

  return (
    <input
      {...input}
      type="number"
      onClick={() => rest.onClick && rest.onClick()}
      onFocus={() => rest.onFocus && rest.onFocus()}
      style={{ width: '50px', padding: '0px 10px 0px 10px', opacity: rest.disabled ? 0.4 : 1 }}
    />
  );
};

const RepeatAdapter = ({ input: { onChange, value }, title, ...rest }) => {

  return (
    <Checkbox
      flip={() => {
        onChange(title);
        if (rest.mutators) {
          rest.mutators.updateReservationField(title);
          rest.mutators.setFieldTouched('reservation_data', true);
        }
      }}
      status={value === title}
      {...rest}
    />
  );
};


const CallTimeTypeAdapter = ({ input: { onChange, value }, title, selected, ...rest }) => {

  return (
    <Checkbox
      disabled={rest.disabled}
      flip={() => {
        onChange(title.type);
      }}
      status={value === title.type || (value === '' && selected)}
      {...rest}
    />
  );
};


const AgeLimitItem = styled.div`
  font-size: 14px;
  color: #555555;
  font-family: BrandonGrotesque-Regular;
  padding-bottom: 15px;
`;

function AgeLimitAdapter(props: AdapterProps) {
  return (
    <div
      className="row"
      style={{
        paddingLeft: '15px',
        paddingBottom: '25px',
        paddingTop: '12px',
      }}
    >
      <AgeLimitItem>
        Model must be
        <input
          style={{
            width: '50px',
            padding: '0px 10px 0px 10px',
            margin: '0px 10px',
            display: 'inline'
          }}
          value={props.input.value}
          onChange={(val) => props.input.onChange(val)}
          name="age_limit"
        />
        yrs or older to attend
      </AgeLimitItem>
    </div>
  );
}

function RepeatGroupAdapter(props) {
  return (
    <>
      {['daily', 'weekly', 'custom', 'none'].map((item) => (
        <div className="col" key={item}>
          <div className="row">
            <div>
              <FieldWithError name="repeat_type" component={RepeatAdapter} title={item} />
            </div>
            <CategoryName>{item.capitalize()}</CategoryName>
          </div>
        </div>
      ))}
    </>
  );
}


function CallTimeTypesAdapter(props) {

  let selected:string = 'all';

  let types:Array<{type: string, title: string}> = [
    {type: 'all', title: 'All models have same call time'},
    {type: 'individual', title: 'Individual call times'}
  ];

  return (
    <>
      {types.map((item) => (
        <div className="col" key={item.type}>
          <div className="row">
            <div>
              <FieldWithError disabled={props.disabled} name="job_start_date_type" component={CallTimeTypeAdapter} selected={selected === item.type} title={item} />
            </div>
            <CategoryName>{item.title}</CategoryName>
          </div>
        </div>
      ))}
    </>
  );
}

export {
  FieldWithError,
  SelectTypeAdapter,
  ConfigurableSelect,
  SimpleFilledSelect,
  SimpleCheckboxes,
  ErrorShow,
  CheckBoxAdapter,
  CategoriesAdapter,
  CitiesAdapter,
  SpotAdapter,
  RepeatAdapter,
  AgeLimitAdapter,
  RepeatGroupAdapter,
  CallTimeTypesAdapter,
  GroupUpdater,
};
